import React from "react";
import classNames from "classnames";
import "./index.scss";
import { getTranslateTitle } from '../../../utils/objects-util.js';
import i18n from "../../../i18n.js";
import IconButton from "../IconButton/IconButton.jsx";

const SectionItemHeader = ({ column }) => {
  const additionalInformation = i18n.exists(column.title + '_TOOLTIP') ? i18n.t(column.title + '_TOOLTIP') : ''

  return (
    <span key={`sectionItemHeader-${column.title}`} className={classNames("sectionItemHeader")}>
      {getTranslateTitle(column.title)}
      {additionalInformation && (
        <div className={"tooltip-icon"}>
          <IconButton isIcon iconName={"info"} tooltipText={additionalInformation} />
        </div>
      )}
    </span>
  )
};

export default SectionItemHeader;
